var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import classNames from "classnames";
import React, { useRef } from "react";
import { Link } from "@riseart/common";
import { menuItemBoxCls, menuItemBoxImgCls, menuItemBoxDetailsCls, menuItemBoxTitleCls, menuItemBoxTextCls } from "./Box.less";
function MenuItemBox(_ref) {
  var _ref$bold = _ref.bold, bold = _ref$bold === void 0 ? false : _ref$bold, className = _ref.className, external = _ref.external, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, label = _ref.label, href = _ref.href, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? null : _ref$onClick, _ref$obfuscate = _ref.obfuscate, obfuscate = _ref$obfuscate === void 0 ? false : _ref$obfuscate, _ref$obflinkProps = _ref.obflinkProps, obflinkProps = _ref$obflinkProps === void 0 ? null : _ref$obflinkProps, _ref$rel = _ref.rel, rel = _ref$rel === void 0 ? null : _ref$rel, _ref$image = _ref.image, image = _ref$image === void 0 ? null : _ref$image, _ref$text = _ref.text, text = _ref$text === void 0 ? null : _ref$text, opened = _ref.opened;
  var showImages = useRef([false, true].indexOf(opened) > -1 ? opened : true);
  if (!showImages.current && opened) {
    showImages.current = true;
  }
  return /* @__PURE__ */ React.createElement(Link, _extends({
    type: bold && "strong",
    external: !!external,
    href,
    title: title || label,
    className: classNames(menuItemBoxCls, className),
    onClick
  }, typeof onClick === "function" ? {
    onClick
  } : null, {
    obfuscate
  }, obfuscate && obflinkProps ? {
    obflinkProps
  } : null, rel ? {
    rel
  } : null), image && showImages.current ? /* @__PURE__ */ React.createElement("img", {
    src: image,
    alt: "",
    className: menuItemBoxImgCls
  }) : null, label || text ? /* @__PURE__ */ React.createElement("span", {
    className: menuItemBoxDetailsCls
  }, label ? /* @__PURE__ */ React.createElement("span", {
    className: menuItemBoxTitleCls
  }, label) : null, text ? /* @__PURE__ */ React.createElement("span", {
    className: menuItemBoxTextCls
  }, text) : null) : null);
}
__name(MenuItemBox, "MenuItemBox");
export {
  MenuItemBox
};
